(() => {
  if (window.ehCartSuggestBound) return;
  window.ehCartSuggestBound = true;
  const initialized = new WeakMap();
  const savedKey = 'eh365-recommended-saved-v1';
  let saved = [];
  try {
    const value = JSON.parse(localStorage.getItem(savedKey) || '[]');
    if (Array.isArray(value)) saved = value.filter(id => typeof id === 'string');
  } catch (_) {}
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveState = button => {
    const active = saved.includes(button.dataset.ehSuggestSave);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', active ? button.dataset.removeLabel : button.dataset.saveLabel);
  };
  function initialize(panel) {
    if (initialized.has(panel)) return;
    const track = panel.querySelector('[data-eh-suggest-track]');
    const controls = panel.querySelector('[data-eh-suggest-controls]');
    const dots = panel.querySelector('[data-eh-suggest-dots]');
    const previous = panel.querySelector('[data-eh-suggest-direction="-1"]');
    const next = panel.querySelector('[data-eh-suggest-direction="1"]');
    if (!track || !dots) return;
    const state = { positions: [0], index: 0 };
    initialized.set(panel, state);
    function mark() {
      const left = track.scrollLeft;
      state.index = state.positions.reduce((best, position, index) => Math.abs(position - left) < Math.abs(state.positions[best] - left) ? index : best, 0);
      previous.disabled = left <= 2;
      next.disabled = left >= track.scrollWidth - track.clientWidth - 2;
      [...dots.children].forEach((dot, index) => dot.setAttribute('aria-current', String(index === state.index)));
    }
    function measure() {
      if (!track.clientWidth) return;
      const cards = [...track.children];
      if (!cards.length) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 10;
      const cardWidth = cards[0].getBoundingClientRect().width;
      const visible = Math.max(1, Math.floor((track.clientWidth + gap) / (cardWidth + gap)));
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const positions = [0];
      for (let i = visible; i < cards.length; i += visible) {
        const position = Math.min(max, i * (cardWidth + gap));
        if (position > positions[positions.length - 1] + 2) positions.push(position);
      }
      if (max > positions[positions.length - 1] + 2) positions.push(max);
      state.positions = positions;
      if (dots.children.length !== positions.length) {
        dots.replaceChildren(...positions.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'eh-suggest__dot';
          dot.dataset.ehSuggestPage = String(index);
          dot.setAttribute('aria-label', dots.dataset.pageLabel.replace('[number]', String(index + 1)));
          return dot;
        }));
      }
      controls.hidden = max < 3;
      mark();
    }
    state.go = index => {
      const target = Math.max(0, Math.min(index, state.positions.length - 1));
      track.scrollTo({ left: state.positions[target], behavior: reducedMotion() ? 'instant' : 'smooth' });
    };
    state.measure = measure;
    track.addEventListener('scroll', mark, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      state.go(event.key === 'Home' ? 0 : event.key === 'End' ? state.positions.length - 1 : state.index + (event.key === 'ArrowRight' ? 1 : -1));
    });
    panel.querySelectorAll('[data-eh-suggest-save]').forEach(saveState);
    state.resize = new ResizeObserver(measure);
    state.resize.observe(track);
    measure();
  }
  function initializeAll() {
    document.querySelectorAll('[data-eh-suggest]').forEach(initialize);
  }
  function start() {
    initializeAll();
    const host = document.querySelector('cart-drawer') || document.body;
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.removedNodes) {
          if (node.nodeType !== 1) continue;
          const panels = [...node.querySelectorAll('[data-eh-suggest]')];
          if (node.matches('[data-eh-suggest]')) panels.push(node);
          panels.forEach(panel => initialized.get(panel)?.resize.disconnect());
        }
      }
      initializeAll();
    }).observe(host, { childList: true, subtree: true });
  }
  document.addEventListener('click', async event => {
    const target = event.target.closest('button');
    const panel = target?.closest('[data-eh-suggest]');
    if (!target || !panel || target.disabled) return;
    if (target.matches('[data-eh-suggest-save]')) {
      const id = target.dataset.ehSuggestSave;
      const wasSaved = saved.includes(id);
      saved = wasSaved ? saved.filter(value => value !== id) : [...saved, id];
      try { localStorage.setItem(savedKey, JSON.stringify(saved)); } catch (_) {}
      document.querySelectorAll('[data-eh-suggest-save]').forEach(saveState);
      panel.querySelector('[data-eh-suggest-status]').textContent = wasSaved ? target.dataset.removedMessage : target.dataset.savedMessage;
      return;
    }
    const state = initialized.get(panel);
    if (target.matches('[data-eh-suggest-direction]')) {
      state?.go(state.index + Number(target.dataset.ehSuggestDirection));
      return;
    }
    if (target.matches('[data-eh-suggest-page]')) {
      state?.go(Number(target.dataset.ehSuggestPage));
      return;
    }
    if (!target.matches('[data-eh-suggest-add]')) return;
    event.preventDefault();
    target.disabled = true;
    target.setAttribute('aria-busy', 'true');
    const status = panel.querySelector('[data-eh-suggest-status]');
    status.textContent = '';
    const drawer = document.querySelector('cart-drawer');
    const body = new FormData();
    body.append('id', target.dataset.variantId);
    body.append('quantity', '1');
    const sections = drawer?.getSectionsToRender?.().map(section => section.id) || [];
    if (sections.length) {
      body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
    }
    try {
      const response = await fetch(target.dataset.addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : target.dataset.errorMessage);
      if (drawer?.renderContents && data.sections) {
        drawer.renderContents(data);
        initializeAll();
        requestAnimationFrame(() => drawer.querySelector('[data-eh-suggest-track]')?.focus({ preventScroll: true }));
      } else {
        window.location.href = window.routes?.cart_url || '/cart';
      }
    } catch (error) {
      status.textContent = error.message === 'Failed to fetch' ? target.dataset.errorMessage : error.message || target.dataset.errorMessage;
    } finally {
      if (target.isConnected) {
        target.disabled = false;
        target.removeAttribute('aria-busy');
      }
    }
  });
  window.addEventListener('storage', event => {
    if (event.key !== savedKey) return;
    try {
      const value = JSON.parse(event.newValue || '[]');
      if (Array.isArray(value)) saved = value.filter(id => typeof id === 'string');
      document.querySelectorAll('[data-eh-suggest-save]').forEach(saveState);
    } catch (_) {}
  });
  document.addEventListener('shopify:section:load', initializeAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
